export default function (ctx, inject) {
    // Options
    const nuxtConfigOptions = {"searchCategories":["posts"]}

    inject('moduleOptions', nuxtConfigOptions)
}
